<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Manutenção/Melhoria
            </span>
        </b-button>
		<b-modal
			v-model="showModal"
			id="modalInserirMovimentacao"
			hide-footer
		>
			<div slot="modal-title">
				Melhoria/Manutencão de Contrato -
				<b-badge variant="warning">Inserir</b-badge>
			</div>
			<manutencao-form
				tipoOperacao="i"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterManutencoesAtualizadas="$emit('obterManutencoesAtualizadas')"
				:contrato="contrato"
			></manutencao-form>
		</b-modal>
    </div>
</template>

<script>
import ManutencaoForm from './ManutencaoForm'

export default {
	components: {
		ManutencaoForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		}
	},
	
	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
